module.exports = __webpack_public_path__ + "static/media/evRiesg_2.f01a1605.png";